import api from 'app/api'
import { FixMeLater } from 'types'

export const roomService: FixMeLater = api.injectEndpoints({
  endpoints: (build) => {
    return {
      getRooms: build.query({
        query: () => ({ url: 'subscription/list/rooms' }),
        providesTags: ['GET_ROOM'],
      }),
      joinPublicChannel: build.mutation({
        query: ({ channelId: roomId }) => ({
          url: `room/${roomId}/join`,
          method: 'POST',
        }),
      }),
      createConversation: build.mutation({
        query: (args) => ({ url: 'room', method: 'POST', body: args }),
        invalidatesTags: ['CREATE_CONVERSATION'],
      }),
      createMeetingConversation: build.mutation({
        query: (args) => ({ url: 'room/meeting', method: 'POST', body: args }),
        invalidatesTags: ['CREATE_CONVERSATION'],
      }),
      createOtrConversation: build.mutation({
        query: (args) => ({ url: 'room/otr', method: 'POST', body: args }),
        invalidatesTags: ['CREATE_CONVERSATION'],
      }),
      searchConversation: build.mutation({
        query: (args) => ({
          url: `room/list/search/${args}`,
          method: 'GET',
        }),
        invalidatesTags: ['SEARCH_CONVERSATION'],
      }),
      sendPinnedConversations: build.mutation({
        query: ({ roomId, messageId, pinned }) => ({
          url: `/room/${roomId}/message/pin`,
          method: 'PUT',
          body: { messageId, pinned },
        }),
        invalidatesTags: ['SEND_PINNED_MESSAGE'],
      }),
      getPinnedMessagesByRoomId: build.query({
        query: ({ roomId }) => ({
          url: `/room/${roomId}/list/messages/pinned`,
        }),
      }),
      getRoomInfo: build.mutation({
        query: ({ roomId }) => ({
          url: `/room/${roomId}/info`,
        }),
      }),
      getRoomInfoForAdmin: build.query({
        query: ({ roomId }) => ({
          url: `/room/${roomId}/stats`,
        }),
      }),
      updateNotification: build.mutation({
        query: ({ roomId, isMuted, notifyOnlyMentions }) => ({
          url: `/subscription/${roomId}/notification`,
          method: 'PUT',
          body: { isMuted, notifyOnlyMentions },
        }),
        invalidatesTags: ['UPDATE_NOTIFICATION'],
      }),
      updateRoomChannelApparance: build.mutation({
        query: ({ roomId, isAppear }) => ({
          url: `/subscription/${roomId}/toggle/appearance`,
          method: 'PUT',
          body: { isAppear },
        }),
        invalidatesTags: ['UPDATE_APPARANCE'],
      }),
      updateRoomArchive: build.mutation({
        query: ({ roomId, isArchived }) => ({
          url: `/room/${roomId}/archive`,
          method: 'PUT',
          body: { isArchived },
        }),
        invalidatesTags: ['UPDATE_ARCHIVE'],
      }),
      updateRoomArchiveFromAdmin: build.mutation({
        query: ({ roomId, isArchived }) => ({
          url: `/room/${roomId}/archive/admin`,
          method: 'PUT',
          body: { isArchived },
        }),
      }),
      updateChannel: build.mutation({
        query: ({ channelId: roomId, params }) => ({
          url: `room/${roomId}`,
          method: 'PUT',
          body: params,
        }),
        invalidatesTags: ['UPDATE_CHANNEL'],
      }),
      leaveChannel: build.mutation({
        query: ({ roomId }) => ({
          url: `/room/${roomId}/leave`,
          method: 'PUT',
        }),
        invalidatesTags: ['LEAVE_CHANNEL'],
      }),
      view: build.mutation({
        query: ({ roomId }) => ({
          url: `/subscription/${roomId}/view`,
          method: 'GET',
        }),
        invalidatesTags: ['GET_ROOM'],
      }),
      unview: build.query({
        query: ({ roomId, t }) => ({
          url: `/subscription/unview/${roomId}?t=${t}`,
          method: 'GET',
        }),
      }),
      getThreadNotifications: build.query({
        query: ({ roomId, page }) => ({
          url: `notification/${roomId}/list/thread/page/${page}`,
          method: 'GET',
        }),
      }),
      getUnreadThreadCount: build.query({
        query: ({ roomId }) => ({
          url: `notification/${roomId}/thread/unread/count`,
          method: 'GET',
        }),
      }),
      getRoomListForForward: build.query({
        query: () => ({
          url: `room/list/forwards`,
          method: 'GET',
        }),
      }),
      getRoomsBySearch: build.query({
        query: (searchText) => ({
          url: `room/search/forwards/${searchText}`,
          method: 'GET',
        }),
      }),
      inviteParticipant: build.mutation({
        query: (args) => ({
          url: `room/invite/${args.roomId}/${args.meetingId}`,
          method: 'PUT',
          body: args.data,
        }),
      }),
    }
  },
})

export const {
  useLazyUnviewQuery,
  useJoinPublicChannelMutation,
  useLazyGetRoomsQuery,
  useCreateConversationMutation,
  useCreateMeetingConversationMutation,
  useCreateOtrConversationMutation,
  useSearchConversationMutation,
  useSendPinnedConversationsMutation,
  useGetPinnedMessagesByRoomIdQuery,
  useUpdateNotificationMutation,
  useGetRoomInfoMutation,
  useLazyGetRoomInfoForAdminQuery,
  useUpdateRoomChannelApparanceMutation,
  useUpdateRoomArchiveMutation,
  useUpdateRoomArchiveFromAdminMutation,
  useLeaveChannelMutation,
  useViewMutation,
  useLazyGetThreadNotificationsQuery,
  useLazyGetUnreadThreadCountQuery,
  useUpdateChannelMutation,
  useLazyGetRoomListForForwardQuery,
  useLazyGetRoomsBySearchQuery,
  useInviteParticipantMutation,
} = roomService
